import React, { useState } from 'react';
import { FilterHistory, LiteratureFilter } from '../types';
import { useFilters } from '../context/FilterContext.tsx';

interface FilterHistoryPanelProps {
    onRestore?: (filter: LiteratureFilter) => void;
}

export function FilterHistoryPanel({ onRestore }: FilterHistoryPanelProps) {
    const { lit_filter, setLitFilter } = useFilters();

    const [histories, setHistories] = useState<FilterHistory[]>(() => {
        const saved = localStorage.getItem('filterHistory');
        return saved ? JSON.parse(saved) : [];
    });
    const [saveName, setSaveName] = useState('');

    const saveCurrentFilters = () => {
        if (!saveName) return;

        const newHistory: FilterHistory = {
            id: Date.now().toString(),
            name: saveName,
            timestamp: new Date().toISOString(),
            filters: lit_filter
        };

        const updatedHistory = [...histories, newHistory];
        setHistories(updatedHistory);
        localStorage.setItem('filterHistory', JSON.stringify(updatedHistory));
        setSaveName('');
    };

    const deleteHistory = (id: string) => {
        const updatedHistory = histories.filter(h => h.id !== id);
        setHistories(updatedHistory);
        localStorage.setItem('filterHistory', JSON.stringify(updatedHistory));
    };

    const handleRestore = (filter: LiteratureFilter) => {
        setLitFilter(filter);
        onRestore?.(filter);
    };

    return (
        <div className="filter-history-panel">
            <div className="save-filters">
                <input
                    type="text"
                    value={saveName}
                    onChange={(e) => setSaveName(e.target.value)}
                    placeholder="Name this filter combination"
                    className="filter-name-input"
                />
                <button onClick={saveCurrentFilters}>Save Current Filters</button>
            </div>

            <div className="history-list">
                <h3>Saved Filters</h3>
                {histories.map(history => (
                    <div key={history.id} className="history-item">
                        <div className="history-info">
                            <strong>{history.name}</strong>
                            <span>{new Date(history.timestamp).toLocaleString()}</span>
                        </div>
                        <div className="history-actions">
                            <button onClick={() => handleRestore(history.filters)}>Restore</button>
                            <button onClick={() => deleteHistory(history.id)}>Delete</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}